<template>
    <div class="logo-title">
        <div class="title">
            <div class="line" v-if="line"></div>
            <h3 :style="getH3Color">{{titleData.title}}</h3>
            <div class="line" v-if="line"></div>
        </div>

        <p :style="getLetterSpace">{{titleData.txt}}</p>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            titleData: {
                type:Object,
                default(){
                    return{
                    }
                }
            },
            line:{
                type:Boolean,
                default:true
            },
            bg: {
                type:Boolean,
                default:true
            }
        },
        computed: {
            getLetterSpace() {
                return {letterSpacing:this.titleData.space+'px',color:this.bg?'#b2b2b2':'#fff'}
            },
            getH3Color() {
                return {color: this.bg ? '#252525':'#fff'}
            }
        }
    }
</script>

<style scoped lang="less">
    .logo-title {
        padding: 40px 0;
        text-align: center;


        .title {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            justify-content: center;
            padding: 0 95px 10px;
            h3 {
                font-size: 36px;
                color: #252525;
                padding: 0 20px;
                white-space: nowrap;
            }
            .line {
                width: 100%;
                height: 1px;
                background: #929292;
            }
        }
        p {
            font-size: 18px;
            color: #b2b2b2;
        }
    }
</style>